/**
 * Passcode rules for every client report page (campaign, advertiser, creator).
 * Kept out of the feature folders so the shared PinCell in components/ui can
 * flag a weak PIN without depending on Ad Ops code.
 */

/** Mirrors creatorPagesFirestore WEAK_PINS — refused for generated and admin-set pins alike. */
export const WEAK_PINS = new Set(['0000', '1234']);

export const randomPin = (): string => {
  for (;;) {
    const pin = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
    if (!WEAK_PINS.has(pin)) return pin;
  }
};

/** Same message the backend PIN_SCHEMA returns, so inline validation and the 400 agree. */
export const pinProblem = (pin: string): string | null => {
  if (!/^\d{4}$/.test(pin)) return 'PIN must be exactly 4 digits';
  if (WEAK_PINS.has(pin)) return 'PIN is too easily guessed — choose a less common 4-digit code';
  return null;
};
